import React, { useEffect, useRef, useState } from "react";

// Propiedades del componente: children (el texto), className opcional y estilos opcionales

interface AutoShrinkTextProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const AutoShrinkText: React.FC<AutoShrinkTextProps> = ({
  children,
  className = "",
  style = {},
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const ajustarTexto = () => {
      if (!containerRef.current || !textRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;
      const textWidth = textRef.current.scrollWidth;

      const newScale =
        textWidth > containerWidth ? containerWidth / textWidth : 1;
      setScale(newScale);
    };
    // Con setscale previamente se guarda la nueva escala y se ajusta el texto en caso de que se cambien las dimensiones de la ventana
    ajustarTexto();
    window.addEventListener("resize", ajustarTexto);
    return () => window.removeEventListener("resize", ajustarTexto);
  }, [children]);

  return (
    <div
      ref={containerRef}
      className={`overflow-hidden flex items-center justify-center ${className}`}
      style={{ ...style, whiteSpace: "nowrap" }}
    >
      <div
        ref={textRef}
        style={{
          transform: `scale(${scale})`,
          transformOrigin: "center",
          display: "inline-block",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default AutoShrinkText;
